import React, {useState, useEffect} from 'react'
import {Table, Button} from 'antd'
import {Plus} from 'lucide-react'
import {useNavigate} from 'react-router-dom'
import {APIv1 as API} from '../../api'
import {useTranslation} from "react-i18next";
import VersionsColumns from "./version.constants";
import {getAuthHeaders, normalVersionConfig} from './version.config'

const Version = ({config = normalVersionConfig}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const columns = VersionsColumns(t, config);
    const [versionData, setVersionData] = useState([])
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [hoveredVersion, setHoveredVersion] = useState(null)
    const isStaff = Boolean(userData?.data?.is_admin)

    function extractFileName(url) {
        if (!url) return null

        const cleanUrl = url.split('?')[0]
        const parts = cleanUrl.split('/')
        return parts[parts.length - 1] || null
    }

    async function getVersionData() {
        if (!userData.token) return

        setLoading(true)
        try {
            const response = await API.get(config.endpoints.list, {
                headers: getAuthHeaders(userData.token),
            });

            const items = Array.isArray(response.data)
                ? response.data
                : response.data?.results || []

            const data = items.map(item => ({
                key: item.id,
                version_id: item.id,
                version_number: item.version_number,
                status: item.status,
                devices_count: item.devices_count,
                companies_count: item.companies_count,
                file: item.file_name || extractFileName(item.file) || '-',
                file_url: item.file,
                is_save_remotely: item.is_save_remotely
            }))
            setVersionData(data)
        } catch (err) {
            console.error('Something went wrong:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, []);

    useEffect(() => {
        getVersionData()
    }, [userData.token, config])

    return (
        <>
            <div className='content_container'>
                {isStaff && (
                    <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 16}}>
                        <Button
                            type='primary'
                            icon={<Plus size={16}/>}
                            onClick={() => navigate(config.routes.create())}
                            style={{borderRadius: 24}}
                        >
                            {t(config.createButtonKey)}
                        </Button>
                    </div>
                )}
                <Table
                    columns={columns}
                    dataSource={versionData}
                    onRow={(record, index) => ({
                        onMouseEnter: () => setHoveredVersion({...record, index}),
                        onMouseLeave: () => setHoveredVersion(null),
                    })}
                    pagination={false}
                    loading={loading}
                />
            </div>
        </>
    )
}

export default Version
